import { render, staticRenderFns } from "./chatClient.vue?vue&type=template&id=d79aefdc&scoped=true&"
import script from "./chatClient.vue?vue&type=script&lang=js&"
export * from "./chatClient.vue?vue&type=script&lang=js&"
import style0 from "./chatClient.vue?vue&type=style&index=0&lang=css&"
import style1 from "./chatClient.vue?vue&type=style&index=1&id=d79aefdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79aefdc",
  null
  
)

export default component.exports